const className = 'checkout'
var state = JSON.parse(sessionStorage.getItem(className))
if (!state) {
  state = []
} else {
  state = JSON.parse(sessionStorage.getItem(className))
}

const mutations = {
  INIT_STATE: state => {
    state = []
    sessionStorage.setItem(className, JSON.stringify(state))
  },
  INSERT_STATE: (state, data) => {
    state = sessionStorage.getItem(className)
    if (!state) {
      state = []
    } else {
      state = JSON.parse(sessionStorage.getItem(className))
    }
    if (Object.prototype.toString.call(data) === '[object Object]') {
      state.push(data)
    } else {
      for (var i = 0; i < data.length; i++) {
        state.push(data[i])
      }
    }
    sessionStorage.setItem(className, JSON.stringify(state))
  },
  REMOVE_STATE: (state, uid) => {
    state = sessionStorage.getItem(className)
    if (!state) {
      state = []
    } else {
      state = JSON.parse(sessionStorage.getItem(className))
    }

    for (var i = 0; i < state.length; i++) {
      if (state[i].uid === uid) {
        state.splice(state, 1)
      }
    }
    sessionStorage.setItem(className, JSON.stringify(state))
  }
}

const actions = {
  initState ({ commit }) {
    commit('INIT_STATE')
  },
  insertState ({ commit }, data) {
    commit('INSERT_STATE', data)
  },
  removeState ({ commit }, uid) {
    commit('REMOVE_STATE', uid)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout.js